import {Component, HostBinding, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { Report, IncomeStatement, FieldValue, Adjustment, AdjustmentModifyRequest, AdjustmentYear, AdjustmentYearModifyRequest, Location, Ownership } from 'src/app/model';
import { AdjustmentType, EntityType, FooterButtonOption, IncomeStatementType, PageNumbers } from 'src/app/model/Enums';
import { ReportProvider } from 'src/app/providers';
import {CommonService, ReportService, ToasterService} from 'src/app/services';
import { NgForm } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CurrencyPipe } from 'src/app/pipes';
import { ReportPageInterface } from 'src/app/interface';
import * as _ from 'lodash';
import { ConfirmPopupComponent } from 'src/app/components';
import { LocationRentAdjustment } from 'src/app/model/location-rent-adjustment';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import {routeTransition} from '../../../../animations/route-transition';

@Component({
  selector: 'app-adjustments',
  templateUrl: './adjustments.component.html',
  styleUrls: ['./adjustments.component.scss'],
  animations: [routeTransition],
  encapsulation: ViewEncapsulation.Emulated
})
export class AdjustmentsComponent implements OnInit, OnDestroy, ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  @ViewChild('adjustmentForm') adjustmentForm: NgForm;

  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  adjustmentType: any[] = [];
  adjustmentTypeEnum = AdjustmentType;

  IncomeStatementTable: IncomeStatement[] = [];

  deleteInProgrss: boolean = false;
  isForm1065: boolean = false;
  isEditMode: boolean = false;

  expandNormalizedIncomeStatement: boolean = true;
  expandInterestandNonCashAdjustments: boolean = false;
  expandOwnerSalaryAdjustments: boolean = false;
  expandFairMarketRentAdjustments: boolean = false;

  zeroValue: number = 0;

  hiRsOwner: Ownership = new Ownership();
  lowRsOwner: Array<Ownership> = [];

  isEllipsis: boolean = true;

  constructor(
    public reportService: ReportService,
    private toastr: ToasterService,
    private router: Router,
    private modalService: BsModalService,
    public currencyPipe: CurrencyPipe,
    private reportProvider: ReportProvider,
    public common: CommonService
  ) { }

  ngOnInit(): void {
    this.adjustmentType.push({ key: 'Non-Recurring Expense', value: AdjustmentType.NON_RECURRING_EXPENSE });
    this.adjustmentType.push({ key: 'Non-Operating Expense', value: AdjustmentType.NON_OPERATING_EXPENSE });
    this.adjustmentType.push({ key: 'Non-Recurring Income', value: AdjustmentType.NON_RECURRING_INCOME });
    this.adjustmentType.push({ key: 'Non-Operating Income', value: AdjustmentType.NON_OPERATING_INCOME });
    this.adjustmentType.push({ key: 'Other', value: AdjustmentType.OTHER });

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport && this.currentReport.LATEST) {
        this.isForm1065 = this.currentReport.LATEST.COMPANY.ENTITY_TYPE == EntityType.FORM_1065;
        this.currentReport.LATEST.OWNERSHIP_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
        this.currentReport.LATEST.LOCATION_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));

        if (this.currentReport.LATEST.INCOME_STATEMENT.length) {
          this.currentReport.LATEST.INCOME_STATEMENT.forEach(element => {
            if (element.IS_TYPE != IncomeStatementType.FORECASTED && element.IS_TYPE != IncomeStatementType.INTERIM) {
              this.IncomeStatementTable.push(element);
            }
          });
          this.IncomeStatementTable.sort((a, b) => Number(a.YEAR) - Number(b.YEAR));

          // add FORECASTED year
          if (this.currentReport.LATEST.INCOME_STATEMENT.find(el => el.IS_TYPE == IncomeStatementType.FORECASTED)) {
            this.IncomeStatementTable.push(this.currentReport.LATEST.INCOME_STATEMENT.find(el => el.IS_TYPE == IncomeStatementType.FORECASTED));
          }
        }

        if (this.reportService.hasOwnershipAdjustments()) {
          this.hiRsOwner = this.reportService.getRSOwnerHi();
          this.lowRsOwner = this.reportService.getRSOwnerLow();
        }

        if (this.currentReport.LATEST.ADJUSTMENT_LIST.length) {
          this.getUpdatedAdjustment();
        } else {
          this.callDummyUpdateAPI();
        }
      }
    });

  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  getUpdatedAdjustment() {

    this.reportProvider.getAdjustment(this.currentReport.LATEST.ID).subscribe(resp => {
      if (resp.success) {
        this.currentReport.LATEST.ADJUSTMENT_LIST = _.cloneDeep(resp.result);
        for (let i = 0; i < this.currentReport.LATEST.ADJUSTMENT_LIST.length; i++) {
          this.currentReport.LATEST.ADJUSTMENT_LIST[i].ADJUSTMENT_TYPE = this.currentReport.LATEST.ADJUSTMENT_LIST[i].ADJUSTMENT_TYPE ? this.currentReport.LATEST.ADJUSTMENT_LIST[i].ADJUSTMENT_TYPE : null;
          this.currentReport.LATEST.ADJUSTMENT_LIST[i].ADJUSTMENT_YEAR_LIST.sort((a, b) => Number(a.INCOME_STATEMENT.YEAR) - Number(b.INCOME_STATEMENT.YEAR));
        }
        setTimeout(() => {
          this.currentReport.LATEST.ADJUSTMENT_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
          this.callDummyUpdateAPI();
        }, 5);
      }
    }, err => {
      // Error Handling
    });

  }

  /**
   * @description for add adjustment
   */
  addMiddleRow() {
    this.toastr.info('Please wait a moment!');

    let dataMiddle = new AdjustmentModifyRequest();
    dataMiddle.ID = null;
    dataMiddle.NAME = null;
    dataMiddle.ADJUSTMENT_TYPE = null;
    dataMiddle.ADJUSTMENT_YEAR_LIST = [];
    for (let i = 0; i < this.IncomeStatementTable.length; i++) {
      const element = this.IncomeStatementTable[i];
      let adjYear = new AdjustmentYearModifyRequest();
      adjYear.INCOME_STATEMENT_ID = element.ID;
      adjYear.Year = element.YEAR;
      adjYear.financialType = element.FINANCIAL_TYPE;
      adjYear.VALUE = 0;
      dataMiddle.ADJUSTMENT_YEAR_LIST.push(adjYear);
    }
    dataMiddle.ADJUSTMENT_YEAR_LIST.sort((a, b) => Number(a.Year) - Number(b.Year));

    this.reportProvider.saveAdjustment(this.currentReport.LATEST.ID, dataMiddle).subscribe(resp => {
      if (resp.success) {
        const existingAdj = _.cloneDeep(this.currentReport.LATEST.ADJUSTMENT_LIST);
        let savedResult = Adjustment.parse(resp.result);
        savedResult.ADJUSTMENT_TYPE = null;
        savedResult.ADJUSTMENT_YEAR_LIST.sort((a, b) => Number(a.INCOME_STATEMENT.YEAR) - Number(b.INCOME_STATEMENT.YEAR));
        existingAdj.push(savedResult);
        this.currentReport.LATEST.ADJUSTMENT_LIST = [];
        this.currentReport.LATEST.ADJUSTMENT_LIST = existingAdj;

        this.currentReport.LATEST.ADJUSTMENT_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
      } else {
        this.toastr.error(resp.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for delete adjustment
   * @param adjustmentId which adjustment we want to delete
   * @param index position
   */
  deleteMiddleRow(adjustmentId: string, index: number) {

    let confirmModalRef: BsModalRef;
    confirmModalRef = this.modalService.show(ConfirmPopupComponent, Object.assign({
      initialState: {
        message: 'Do you want to delete adjustment?'
      }
    }, { class: 'modal-sm modal-dialog-centered' }));

    const ackSubject = new Subject<boolean>();
    confirmModalRef.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        this.deleteInProgrss = true;
        this.reportProvider.deleteAdjustment(this.currentReport.LATEST.ID, adjustmentId).subscribe(resp => {
          if (resp.success) {
            const existingAdj = _.cloneDeep(this.currentReport.LATEST.ADJUSTMENT_LIST);
            const deletedIndex = existingAdj.findIndex(el => el.ID == adjustmentId);
            existingAdj.splice(deletedIndex, 1);
            this.currentReport.LATEST.ADJUSTMENT_LIST = [];
            this.currentReport.LATEST.ADJUSTMENT_LIST = existingAdj;

            this.toastr.success('Normalizing Adjustment deleted successfully!');
            this.deleteInProgrss = false;
          } else {
            this.toastr.error(resp.error.txt);
            this.deleteInProgrss = false;
          }
        }, err => {
          // Error Handling
          this.deleteInProgrss = false;
        });
      }
    });
  }

  /**
   * @description for update adjustment detail
   * @param fieldName which field we want to update
   * @param obj adjustment object
   */
  updateAdjustmentCell(fieldName: string, obj: Adjustment, index: number = 0) {
    if (fieldName == 'ADJUSTMENT_TYPE') {
      this.adjustmentForm.controls['NAME_' + index].markAsTouched();
    }
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'ADJUSTMENT';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = obj[fieldName] || '';
    objFieldValue.REFRESH = 'ADJUSTMENTS';
    this.reportProvider.updateReportField(obj.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for update adjustment year detail
   * @param fieldName which field we want to update
   * @param obj adjustment year object
   */
  updateAdjustmentYearCell(fieldName: string, obj: AdjustmentYear) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'ADJUSTMENT_YEAR';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = Number(obj[fieldName]) || 0;
    objFieldValue.REFRESH = 'ADJUSTMENTS';
    this.reportProvider.updateReportField(obj.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for update income statement detail
   * @param fieldName which field we want to update
   * @param obj income statement object
   */
  updateIncomeTableValue(fieldName: string, obj: IncomeStatement) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'INCOME_STATEMENT';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = obj[fieldName];
    objFieldValue.REFRESH = 'ADJUSTMENTS';
    this.reportProvider.updateReportField(obj.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for update location->rent detail
   * @param fieldName which field we want to update
   * @param obj location object
   */
  updateLocationRentValue(fieldName: string, obj: Location) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'LOCATION';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = obj[fieldName];
    objFieldValue.REFRESH = 'ADJUSTMENTS';
    this.reportProvider.updateReportField(obj.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for update owner salary detail
   * @param fieldName which field we want to update
   * @param obj owner object
   */
  updateOwnerSalaryValue(fieldName: string, obj: Ownership) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'OWNERSHIP';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = obj[fieldName];
    objFieldValue.REFRESH = 'ADJUSTMENTS';
    this.reportProvider.updateReportField(obj.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  updateReportVersionValue(fieldName: string) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'REPORT_VERSION';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST[fieldName].trim();
    objFieldValue.REFRESH = 'ADJUSTMENTS';
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for call dummy update API call for get WS
   */
  callDummyUpdateAPI() {
    this.reportProvider.updateWS(this.currentReport.LATEST.ID, 'INCOME_STATEMENT').subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  getCurrentRentExpense(ray: Array<LocationRentAdjustment>, istId: string): number {
    if (ray.length) {
      const location = ray.find(el => el.INCOME_STATEMENT.ID == istId);
      return location?.VALUE || null;
    }
  }

  updateLocationCurrentRentValue(ray: Array<LocationRentAdjustment>, istId: string) {
    if (ray.length) {

      const rayLocation = ray.find(el => el.INCOME_STATEMENT.ID == istId);

      let objFieldValue = new FieldValue();
      objFieldValue.GROUP = 'RENT_ADJUSTMENT_YEARLY';
      objFieldValue.FIELD = 'VALUE';
      objFieldValue.VALUE = rayLocation.VALUE;
      objFieldValue.REFRESH = 'ADJUSTMENTS';
      this.reportProvider.updateReportField(rayLocation.ID, objFieldValue).subscribe(res => {
        if (!res.success) {
          this.toastr.error(res.error.txt);
        }
      }, err => {
        // Error Handling
      });
    }
  }

  currentRentChange(ray: Array<LocationRentAdjustment>, istId: string, event: any) {
    ray.find(el => el.INCOME_STATEMENT.ID == istId).VALUE = event;
  }

  getSalaryAdjustmentsTotal(ist: IncomeStatement): number {
    let lowRsOwnerTotal: number = 0;
    let UnnamedGmTotal: number = 0;
    if (this.reportService.hasOwnershipAdjustments()) {
      lowRsOwnerTotal = this.lowRsOwner.reduce((summ, v) => (summ += (Number(v.REPLACEMENT_SALARY) + this.reportService.calculateTaxAdjustment(v.REPLACEMENT_SALARY)) || 0), 0);
    }
    if (this.reportService.hasOwnershipUnnamedGmAdjustments()) {
      UnnamedGmTotal = (ist.GM_SALARY || 0) + (this.reportService.calculateTaxAdjustment(ist.GM_SALARY) || 0);
    }
    if (this.isForm1065) {
      return Number(ist.GUARANTEED_PAYMENTS) + Number(ist.OFFICER_COMP) + this.reportService.calculateTaxAdjustment(ist.OFFICER_COMP) - (lowRsOwnerTotal + UnnamedGmTotal);
    } else {
      return Number(ist.OFFICER_COMP) + this.reportService.calculateTaxAdjustment(ist.OFFICER_COMP) - (lowRsOwnerTotal + UnnamedGmTotal);
    }
  }

  getRentAdjustmentsTotal(ist: IncomeStatement): number {
    let rentExpenseTotal: number = 0;
    this.currentReport?.LATEST?.LOCATION_LIST.forEach(rnt => {
      if (rnt.RENT_EXPENSE_EACH_YEAR) {
        rentExpenseTotal += Number(this.getCurrentRentExpense(rnt.RENT_ADJUSTMENT_YEARLY, ist.ID));
      } else if (!rnt.RENT_EXPENSE_EACH_YEAR) {
        rentExpenseTotal += Number(rnt.RENT_EXPENSE);
      }
    });

    const simpleRentTotal = this.currentReport?.LATEST?.LOCATION_LIST.reduce((summ, v) => (summ += Number(v.MARKET_RENT) || 0), 0);
    return rentExpenseTotal - simpleRentTotal;
  }

  checkGeneralManagerTaxes(): boolean {
    return this.IncomeStatementTable.some(el => el.FINANCIAL_TYPE != 'NOT_AVAILABLE' && !el.GM_SALARY_TAX);
  }


  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return (!this.adjustmentForm.invalid || this.currentReport?.isLocked);
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.ADJUSTMENTS);
      if (this.reportService.showWeighting()) {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/weighting/weighting-table`);
      } else {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/projections/projection-table`);
      }
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      if (this.reportService.showOwnershipSalary() == 1) {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/salary/manager-salary`);
      } else if (this.reportService.showOwnershipSalary() == 2) {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/salary/replacement-salary`);
      } else if (this.reportService.showRentAdjustments()) {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/rent/rent-details`);
      } else {
        // this.router.navigateByUrl(`/report/${this.currentReport.ID}/income/future-year`);
        /// this.router.navigateByUrl(`/report/${this.currentReport.ID}/income`);
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/future-projection`);
      }
    } else if (buttonOption == FooterButtonOption.SKIP_CLICK) {
      this.isEditMode = !this.isEditMode;
      if (this.isEditMode) {
        this.expandNormalizedIncomeStatement = true;
        this.expandInterestandNonCashAdjustments = true;
        this.expandOwnerSalaryAdjustments = true;
        this.expandFairMarketRentAdjustments = true;
      }
    }

  }

}
